export const setLocalStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);
};

export const getLocalStorage = (key: string) => {
  return localStorage.getItem(key);
};

export const removeLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};

export const clearLocalStorage = () => {
  localStorage.clear();
};

export const setUserTokenToLocalStorage = (token: string) => {
  setLocalStorage('nps-token', token);
};

export const getUserTokenFromLocalStorage = () => {
  return getLocalStorage('nps-token');
};

export const removeUserTokenFromLocalStorage = () => {
  removeLocalStorage('nps-token');
};
